var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isShowModal())?_c('ModalLayout',{attrs:{"title":_vm.setModalTitle(),"mStyle":_vm.setModalSize(),"isEmit":true,"noFooter":true},on:{"cancel":_vm.close}},[_c('NoticeView')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }